module.exports = __webpack_public_path__ + "bin/faae31f6ad7247ba24dc7df4e626fda9.woff2";